import { BookOpenText, Buildings, Terminal, Users } from "@phosphor-icons/react"
import { Icon } from "@tokenterminal/core/ui/icon/Icon"
import Container from "../common/Container"
import MarketingHeading from "../common/MarketingHeading"

const WhoWeServeSection = () => {
  const whoWeServeWithSubtitles = [
    {
      label: "Institutional investors",
      subtitle: "Allocating capital with trusted digital asset data",
      icon: Buildings,
    },
    {
      label: "Research and data platforms",
      subtitle: "Powering products with standardized onchain data",
      icon: BookOpenText,
    },
    {
      label: "Protocol teams and foundations",
      subtitle: "Measuring ecosystem growth and financial activity",
      icon: Users,
    },
    {
      label: "Developers and analysts",
      subtitle: "Seeking raw-to-standardized data access",
      icon: Terminal,
    },
  ]

  return (
    <div className="py-24 md:py-32">
      <Container>
        <div className="max-w-[900px] mx-auto flex flex-col gap-8">
          <MarketingHeading level={2} className="text-[28px] md:text-[40px]">
            Who we serve
          </MarketingHeading>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {whoWeServeWithSubtitles.map((item, idx) => (
              <div
                key={idx}
                className="flex items-start gap-3 p-5 border border-solid border-border-default rounded-xl [--line-height:1.3rem]"
              >
                <div className="size-[var(--line-height)] shrink-0 flex items-center justify-center">
                  <Icon as={item.icon} width={20} className="text-fg-secondary shrink-0" />
                </div>
                <div className="flex flex-col gap-1">
                  <span
                    className="text-base font-medium tracking-tight"
                    style={{ lineHeight: "var(--line-height)" }}
                  >
                    {item.label}
                  </span>
                  <span className="text-sm text-fg-secondary">{item.subtitle}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Container>
    </div>
  )
}

export default WhoWeServeSection
